import * as React from "react"
import { useState } from 'react'

const SvgComponent = (props) => {

  const color = (props.hover === true) ? '#dd9101' : "#f5f5f5"  
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={35.75}
      height={35.75}
      {...props}
      style={{ transform: "scale(0.9)" }}
    >
      <g
        data-name="ic-actions-notifications"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.75}
      >
        <path
          data-name="Path 27"
          d="M30.709 28.875H5.042l4.07-20.313a8.91 8.91 0 0 1 8.763-7.187h0a8.91 8.91 0 0 1 8.767 7.187Z"
        />
        <path data-name="Line 51" d="M1.375 28.375h33" />
        <path data-name="Path 28" d="M23.375 28.875a5.5 5.5 0 0 1-11 0" />
      </g>
    </svg>
  )
}

export default SvgComponent
